import React from "react";
import { Link } from "react-router-dom";

function StudentsList({schoolStudents, studentsFirst}) {

    return (
        <table className="table display data-table text-nowrap">
            <thead>
              <tr>
              <th scope="col" >No.</th>
              <th>Names</th>
              <th>Student Code</th>
              <th>Class</th>
              </tr>
            </thead>
            <tbody>
              {schoolStudents.length > 0 ? (
                schoolStudents.map((item, index) => (
                  <tr key={index}>
                     <td>{index + studentsFirst + 1}</td>
                     
                    <td><Link to={`../students/profile/${item.student_id}/${item.user_id}`}>
                                                    {item.full_name}
                                                    </Link></td>
                    <td>{item.username}</td>
                    <td>{item.group}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No students registered in this school yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        
    );
}

export default StudentsList;
